import React from 'react'
import { Card, CardContent, CardHeader, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material'
import { formatNumber } from '../../../../helpers/UtilityHelper'

const CancellationReasons = ({ cancellationReasonsSummary }) => {
    if (!cancellationReasonsSummary || !cancellationReasonsSummary.reasons || cancellationReasonsSummary.reasons.length === 0) return null

    const { reasons, grandTotals } = cancellationReasonsSummary

    return (
        <Card elevation={1}>
            <CardHeader
                title="NDR Cancellation Reasons"
                subheader="Distribution of reasons for NDR shipments that resulted in RTO"
            />
            <CardContent>
                <TableContainer component={Paper} sx={{ maxHeight: 500 }}>
                    <Table stickyHeader size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{ fontWeight: 'bold', fontSize: '0.75rem', backgroundColor: '#FFF9C4' }}>Reason</TableCell>
                                <TableCell align="center" sx={{ fontWeight: 'bold', fontSize: '0.75rem', backgroundColor: '#FFF9C4' }}>Count</TableCell>
                                <TableCell align="center" sx={{ fontWeight: 'bold', fontSize: '0.75rem', backgroundColor: '#FFF9C4' }}>Percentage</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {reasons.map((reason) => (
                                <TableRow key={reason}>
                                    <TableCell sx={{ fontSize: '0.75rem' }}>{reason}</TableCell>
                                    <TableCell align="center" sx={{ fontSize: '0.75rem' }}>{formatNumber(grandTotals[reason])}</TableCell>
                                    <TableCell align="center" sx={{ fontSize: '0.75rem' }}>
                                        {grandTotals.total > 0
                                            ? `${((grandTotals[reason] / grandTotals.total) * 100).toFixed(1)}%`
                                            : '0%'}
                                    </TableCell>
                                </TableRow>
                            ))}
                            <TableRow sx={{ backgroundColor: '#333' }}>
                                <TableCell sx={{ color: '#fff', fontWeight: 'bold', fontSize: '0.75rem' }}>Grand Total</TableCell>
                                <TableCell align="center" sx={{ color: '#fff', fontWeight: 'bold', fontSize: '0.75rem' }}>{formatNumber(grandTotals.total)}</TableCell>
                                <TableCell align="center" sx={{ color: '#fff', fontWeight: 'bold', fontSize: '0.75rem' }}>100%</TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            </CardContent>
        </Card>
    )
}

export default CancellationReasons
